import { takeEvery, takeLatest } from 'redux-saga/effects';
import { onScreenshareSelectedSaga } from 'features/screenshare/sagas/onScreenshareSelectedSaga';
import { onShowAllScreensChangedSaga } from 'features/screenshare/sagas/onShowAllScreensChangedSaga';
import { toggleLocalScreenshareSaga } from 'features/screenshare/sagas/toggleLocalScreenshareSaga';
import {
  localScreenshareToggled,
  screenshareSelected,
  screenshareStoppedRemotely,
  stopRemoteScreenshare,
  localScreenshareStopped,
} from 'features/screenshare/actions';
import {
  gridDimensionsChanged,
  showAllScreensChanged,
} from 'features/screenshare/screenshareSlice';
import { stopRemoteScreenshareSaga } from 'features/screenshare/sagas/stopRemoteScreenshareSaga';
import { onScreensharingStoppedRemotelySaga } from 'features/screenshare/sagas/onScreensharingStoppedRemotelySaga';
import { stopLocalScreenshareSaga } from 'features/screenshare/sagas/stopLocalScreenshareSaga';
import { onDimensionsChangedSaga } from 'features/screenshare/sagas/onDimensionsChangedSaga';

export default function* screenshareWatcher() {
  yield takeLatest(localScreenshareToggled, toggleLocalScreenshareSaga);
  yield takeLatest(localScreenshareStopped, stopLocalScreenshareSaga);

  yield takeLatest(showAllScreensChanged, onShowAllScreensChangedSaga);
  yield takeLatest(gridDimensionsChanged, onDimensionsChangedSaga);

  yield takeLatest(stopRemoteScreenshare, stopRemoteScreenshareSaga);
  yield takeLatest(screenshareStoppedRemotely, onScreensharingStoppedRemotelySaga);

  yield takeEvery(screenshareSelected, onScreenshareSelectedSaga);
}
